import Gramaphone from 'assets/images/voice-scan/gramaphone.png';
import { Button } from 'components/ui/button';
import { useTranslation } from 'react-i18next';

export default function ProcessingError({ onReset }: { onReset: () => void }) {
  const { t } = useTranslation();

  return (
    <div className='grid md:grid-cols-2 p-4 gap-6 md:p-12 md:gap-12 lg:gap-20 h-full lg:h-[calc(100vh-8rem)] max-w-6xl mx-auto'>
      <div className='flex flex-col justify-center order-2 md:order-1'>
        <div className='space-y-3'>
          <h1 className='text-xl font-semibold lg:text-2xl'>
            {t('audio_processing_error_title')} ❎
          </h1>
          <p className='font-medium text-[#656D76]'>
            {t('audio_processing_error_info_1')}
          </p>
          <p className='font-medium text-[#656D76]'>
            {t('audio_processing_error_info_2')}
          </p>
        </div>
        <div className='mt-4 bg-[#F1F5F9] rounded-3xl p-4'>
          <h4 className='text-lg font-semibold text-tertiary'>{t('tips')}</h4>
          <p className='font-medium text-[#656D76] mt-2 mb-1'>
            {t('audio_error_tips_message')}
          </p>
          <ul className='list-disc pl-4 font-medium text-[#656D76] space-y-1'>
            <li>{t('audio_error_tips_1')}</li>
            <li>{t('audio_error_tips_2')}</li>
            <li>{t('audio_error_tips_3')}</li>
          </ul>
        </div>

        <div className='flex justify-center mt-6'>
          <Button size='sm' className='px-8' onClick={onReset}>
            {t('retry')}
          </Button>
        </div>
      </div>
      <div className='grid order-1 place-content-center md:order-2'>
        <img src={Gramaphone} alt='gramaphone' />
      </div>
    </div>
  );
}
